module.exports = __webpack_public_path__ + "img/canpay-logo-lite.cd8bf2de.png";